export function formatThousandSeparator(number = 0) {
  return new Intl.NumberFormat('id-ID', {
    currency: 'IDR'
  }).format(number)
}

export function firstLetterUpperCase(text = '') {
  if (text === null || text === undefined) return ''
  const strText = String(text)
  return strText.toLowerCase().replace(/(?:^|\s)\S/g, function (str) {
    return str.toUpperCase()
  })
}

export function formatNumber(num) {
  if (num === null || num === undefined) return '0.00'
  return parseFloat(num).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })
}
